import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { get } from 'lodash';
import DOMPurify from 'dompurify';
import { connect } from 'react-redux';
import { postBookmark, putBookmark, postSegmentEvent } from '../../actions';
import { RuntimeContext } from '../../../../common/RuntimeContext';

class WorkspaceSlideHeader extends Component {
    static propTypes = {
        headerText: PropTypes.string,
        postBookmark: PropTypes.func,
        putBookmark: PropTypes.func,
        bookmarksBySectionItemId: PropTypes.object,
        currentSectionItemId: PropTypes.string,
        currentUserLearningAssetId: PropTypes.string,
        currentLearningAssetId: PropTypes.string,
        currentUser: PropTypes.object,
        currentSectionId: PropTypes.string,
        currentLearningAssetName: PropTypes.string,
        hideBookmark: PropTypes.bool,
        isVerbAdmin: PropTypes.bool,
        userCompany: PropTypes.object,
        isRefSheet: PropTypes.bool,
    };

    static contextType = RuntimeContext

    constructor(props) {
        super(props);
        this.state = {};
    }

    static contextType = RuntimeContext;

    _handleBookmarkClick = () => {
        const {
            postBookmark,
            putBookmark,
            bookmarksBySectionItemId,
            currentSectionItemId,
            currentUserLearningAssetId,
            currentLearningAssetId,
            currentLearningAssetName,
            currentUser,
            currentSectionId,
            currentCollection,
            headerText,
            isVerbAdmin,
            userCompany = {}
        } = this.props;
        postSegmentEvent({
            pathsContext: this.context.pathsWeb,
            body: {
                userCompany,
                customFields: {
                    isVerbAdmin,
                    activityId: currentUserLearningAssetId,
                    userId: currentUser?._id,
                    companyId: userCompany._id || ''
                },
                eventTitle: 'LA: Bookmark'
            }
        });
        const sectionItemBookmark = bookmarksBySectionItemId[currentSectionItemId];
        const { name, _id, permalink, thumbnailImageUrl } = currentCollection;

        if (!sectionItemBookmark) {
            return postBookmark({
                body: {
                    learningAssetName: currentLearningAssetName,
                    sectionItemName: headerText,
                    userLearningAssetId: currentUserLearningAssetId,
                    learningAssetId: currentLearningAssetId,
                    userProfile: currentUser,
                    userCompany,
                    userProfileId: currentUser._id,
                    sectionItemId: currentSectionItemId,
                    sectionId: currentSectionId,
                    isVerbAdmin, 
                    collectionName: name,
                    collectionId: _id,
                    collectionPermalink: permalink,
                    collectionThumbnail: thumbnailImageUrl,

                },
                pathsContext: this.context.pathsWeb
            });
        }
        return putBookmark({
            id: sectionItemBookmark._id,
            body: {
                isDeleted: true
            },
            pathsContext: this.context.pathsWeb
        });
    };

    render() {
        const { headerText, currentSectionItemId, bookmarksBySectionItemId, hideBookmark, isRefSheet = false } = this.props;
        const displayBookmarks =
            !window.location.href.includes('welcome/') &&
            !hideBookmark;

        return (
            <div className={'workspace-slide-header'} style={headerText.length < 1 ? { marginTop: '0px' } : {}}>
                <div className={'header-container'}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(`${isRefSheet ? `<h2 class="verb-title-1-h2 slide-header">${headerText}</h2>` : `<h1 class="verb-title-1 slide-header">${headerText}</h1>`}`)
                        }}
                    />
                </div>
                {displayBookmarks && (
                    <div className={'bookmark-container col-2 col-sm-2'}>
                        <i
                            className={cns('bookmark-icon', {
                                'fas bookmarked': bookmarksBySectionItemId[currentSectionItemId],
                                fal: !bookmarksBySectionItemId[currentSectionItemId],
                                'fa-bookmark': true
                            })}
                            onClick={() => {
                                this._handleBookmarkClick();
                            }}
                        />
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        bookmarks,
        workspace,
        companies,
        collections,
        auth: { loggedInUser, loggedInUserCompanyId, isVerbAdmin },
    } = state;

    const foundCollections = [];
    const currentUserLearningAsset = get(state, 'workspace.currentUserLearningAsset', {});
    const { byId } = collections;
    const collectionList = Object.values(byId);
    (collectionList || []).forEach((collection) => {
        (collection.contentIds || []).forEach((content) => {
            if (content.id === currentUserLearningAsset.learningAssetId) {
                foundCollections.push(collection);
            }
        })
    });

    const currentCollection = foundCollections.sort((a,b) => b.updatedOn - a.updatedOn)[0];

    return {
        userCompany: companies.byId[loggedInUserCompanyId],
        isVerbAdmin,
        loggedInUser,
        bookmarksBySectionItemId: bookmarks.bySectionItemId,
        currentUserLearningAssetId: workspace.currentUserLearningAsset._id,
        currentLearningAssetId: workspace.currentUserLearningAsset.trackId,
        currentLearningAssetName: workspace.currentUserLearningAsset.trackName,
        currentCollection,
    };
};

const mapDispatchToProps = (dispatch) => ({
    postBookmark: (params) => dispatch(postBookmark(params)),
    putBookmark: (params) => dispatch(putBookmark(params))
});

export const WorkspaceSlideHeaderComponent = WorkspaceSlideHeader;

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceSlideHeader);
